<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
          <div class='sub-title-wrap-tab'>
            <ul>
              <li class='float-left sub-title'>{{tab.title}}</li>
            </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>
    <CurrentCoilStock v-if='selectedIndex === 0'/>
    <CurrentPurchaseStock v-if='selectedIndex === 1'/>
    <CurrentProductionStock v-if='selectedIndex === 2'/>
    <CurrentSemiProductionStock v-if='selectedIndex === 3' :goods-code="tabs[3].title"/>
    <CurrentWipStock v-if='selectedIndex === 4' :goods-code="tabs[4].title"/>
  </div>
</template>

<script>
import ConstDef from '../../../share/ConstDef'
import DxTabPanel from 'devextreme-vue/tab-panel'
import CurrentCoilStock from './CurrentCoilStock'
import CurrentPurchaseStock from './CurrentPurchaseStock'
import CurrentProductionStock from './CurrentProductionStock'
import CurrentSemiProductionStock from './CurrentSemiProductionStock'
import CurrentWipStock from './CurrentWipStock'

export default {
  name: 'CurrentStockTab',
  data: function () {
    return {
      selectedIndex: 0,
      tabs: []
    }
  },
  components: {
    DxTabPanel,
    CurrentCoilStock,
    CurrentPurchaseStock,
    CurrentProductionStock,
    CurrentSemiProductionStock,
    CurrentWipStock
  },
  created () {
    document.title = ConstDef.TAB_TITLE
    let user = this.$store.getters.getUserInfo
    console.log(user)
    if (user === undefined || user === null) {
      this.$router.push('/')
    }
    const topMenuTab = this.$store.getters.getTopMenuTabByUrl(this.$route.path)
    if (topMenuTab !== null) {
      const tabNameArray = topMenuTab.multiTabName.split('/')
      for (let i = 0; i < tabNameArray.length; i++) {
        let temp = {}
        temp.title = tabNameArray[i]
        this.tabs.push(temp)
      }
      console.log(this.tabs)
    }
  },
  mounted () {

  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {

  }
}
</script>

<style lang="scss">

</style>
